<div class="body" [formGroup]="formGroup">
    
    <div class="criteria-suggestions">

        <div class="sub-headline">
            Verfügbare Suchfelder für {{currentFilterType? currentFilterType.plural: 'Einträge'}}
        </div>

        <ng-container *ngIf="currentFilterType">

            <ng-container *ngFor="let criteria of currentFilterType.criteria">

                <div *ngIf="criteria.suggestionsProvider; else noSuggestions" class="label"
                    (click)="addCriteria(criteria)" [matMenuTriggerFor]="suggestionMenu">
                    {{criteria.title}}
                </div>
    
                <ng-template #noSuggestions>
                    <div class="label" (click)="addCriteria(criteria)">
                        {{criteria.title}}
                    </div>
                </ng-template>
    
            </ng-container>

        </ng-container>

    </div>

    <mat-form-field class="search-expression" appearance="fill">
        <mat-label>Ausdruck</mat-label>
        <textarea rows=3 [formControl]="filtercriteriaControl" matInput></textarea>
    </mat-form-field>
    <mat-hint>
        Gespeicherte Filterbedingungen können aktuell nicht in einen Ausdruck übersetzt werden. Wenn Sie hier einen neuen Ausdruck eingeben und speichern, dann werden die alten Filterbedingungen überschrieben.
    </mat-hint>

    <div class="help-badge">
        Hilfe
    </div>

    <div *ngIf="!filterControl.value && corruptedConstantInStatement" class="warning-hint">
        Wir haben eine invalide Eingabe erkannt, welche wahrscheinlich an einem falschen Vergleichsoperator
        liegt. Bitte beachten Sie, dass die Filter momentan nur mit '=' (ist gleich) und '!=' (ist ungleich)
        funktionieren.
    </div>

    <div *ngIf="statementValid && !filterControl.value" style="text-align: center;">

        <ng-container *ngFor="let term of compiledStatement">

            <ng-container *ngIf="term.isOperator; else noOperator">

                <div class="term operator" [matMenuTriggerFor]="menu">{{term.value}}</div>

                <mat-menu #menu="matMenu">

                    <button mat-menu-item class="dropdown-item"
                        (click)="setTermOperator('AND', term)">Und</button>

                    <button mat-menu-item class="dropdown-item"
                        (click)="setTermOperator('OR', term)">Oder</button>

                </mat-menu>

            </ng-container>

            <ng-template #noOperator>

                <div class="term" [ngClass]="{
                    'symbol': term.isSymbol,
                    'constant': term.isConstant,
                    'beginParenthesis': term.isBeginParenthesis,
                    'endParenthesis': term.isEndParenthesis
                }">{{term.value}}</div>

            </ng-template>

        </ng-container>

    </div>

    <ng-container *ngIf="filterControl.value">

        <div class="saved-filter-headline">
            Dieser Filter zeigt
            <span class="type">
                {{currentFilterType? currentFilterType.plural: 'Einträge'}}
            </span>
            , für welche gilt:
        </div>
    
        <app-filter-structure-preview [filter]="filterControl.value" [filterType]="currentFilterType"></app-filter-structure-preview>

    </ng-container>

</div>

<mat-menu #suggestionMenu="matMenu">
    <button *ngFor="let suggestion of currentSuggestions" mat-menu-item class="dropdown-item"
        (click)=addCriteriaValue(suggestion)>
        <span>{{ suggestion.title }}</span>
    </button>
</mat-menu>
